import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";
import DashboardHeader from "../../components/DashboardHeader";


//TABS - BOOTSTRAP
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

//TABS - ANT DESIGN
// import { Tabs } from "antd";
import { Progress, Button } from 'antd';

import ApplicationView from "./ApplicationView";
import CustomerView from "../crm/CustomerView";
import ApplicantFinancialsView from "./ApplicantFinancialsView";
// import LoanApproval from "./LoanDecisionModal";
import LoanDecisionModal from "./LoanDecisionModal";

import UserAlerts from "../../components/UserAlerts";


const LoanDecision = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const errorRef = useRef(null);

    const applicationId = params.id


    const [isModalOpen, setIsModalOpen] = useState(false);

    const [removeBorder, setRemoveBorder] = useState(true);

    const [customerId, setCustomerId] = useState(null);
    const [applicationDecision, setApplicationDecision] = useState();

    const { data: customer } = useQuery({
        // queryKey: ['customer', applicationId],
        queryKey: ['customer', customerId],
        queryFn: async () => {
          const response = await authAxios.get(`crm/customers/${customerId}`);
          return response.data
        },
        enabled: !!customerId,
    });


    const { data: application } = useQuery({
        queryKey: ['application', applicationId],
        queryFn: async () => {
          const response = await authAxios.get(`loans/loan-applications/${applicationId}`);
          setCustomerId(response.data.customer)
          return response.data
        },
    });

    //Bootstrap Tabs
    const [key, setKey] = useState('applicant');
    const handleTabChange = (k) => {
        setKey(k)
    };

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    return (
        <div className="dashboard-main">
            {application &&

            // <section className="dashboard-content dashboard-content-compact" style={{ display: 'flex', gap: '1 rem', alignItems: 'flex-start' }}>
            <section className="dashboard-content dashboard-content-compact">
                 <div ref={errorRef}>
                    <UserAlerts error={error} />
                </div>
                <DashboardHeader dashboardTitle={application.customer_name} dashboardPreTitle="Loan Decision" removeBorder={removeBorder} />

                <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>

                    <div style={{ flex: '0 0 70%', marginTop: '1rem' }}>                
                        <Tabs
                            activeKey={key}
                            onSelect={(k) => handleTabChange(k)}
                            className="dashboard-tabs"
                            id="customer-tabs"
                            mountOnEnter={true}
                            unmountOnExit={true}
                            transition={false}
                        >
                            
                            <Tab eventKey="applicant" title="Applicant">
                                <CustomerView
                                    customer={customer}
                                    variant="applicant"
                                    setError={setError}
                                />
                            </Tab>

                            <Tab eventKey="loan-details" title="Loan Details">
                                <ApplicationView
                                    application={application}
                                    setError={setError}
                                />
                            </Tab>
                            
                            <Tab eventKey="financials" title="Financials">
                                <ApplicantFinancialsView
                                    application={application}
                                    setError={setError}
                                />
                            </Tab>

                            <Tab disabled eventKey="guarantors" title="Guarantors">
                            </Tab>

                            <Tab disabled eventKey="security" title="Security">
                            </Tab>
                        </Tabs> 
                    </div>
                    <div style={{ flex: '0 0 30%', marginTop: '6rem' }}>
                        <form noValidate autoComplete="off" >

                            <div 
                                style={{ 
                                    flex: 'auto', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center', 
                                    flexDirection: 'column',
                                    gap: '0.5rem'

                                    }}
                                >
                                <div>
                                    <h5 style={{ textAlign: 'center' }}>Risk Score</h5>
                                </div>

                                <Progress
                                    type="circle"
                                    percent={50}
                                />

                                <div style={{ marginTop: '2rem', display: 'flex', gap: '0.5rem' }}>


                                <Button 
                                    type="primary" 
                                    onClick={()=>{
                                        setIsModalOpen(true);
                                        setApplicationDecision('APPROVE');
                                    }}
                                >
                                    Approve 
                                </Button>

                                <Button 
                                    type="button" 
                                    // htmlType="submit" 
                                    onClick={()=>{
                                        setIsModalOpen(true);
                                        setApplicationDecision('DECLINE');
                                    }}
                                >
                                    Decline
                                </Button>   
                                
                                </div>

                            
                            </div>


                        </form>

                        <LoanDecisionModal 
                            application={application}
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                            applicationDecision={applicationDecision}
                        />

             
                    </div>  
                </div>


            </section>
            }
        </div>
    );
  };
  
  export default LoanDecision;